<template>
  <div id="main">
    <el-row :gutter="10">
      <el-col :xl="3">
        <el-menu
          default-active="2"
          class="el-menu-vertical-demo">
          <el-submenu index="1">
            <template slot="title">
              <i class="el-icon-postcard"></i>
              <span>内容管理</span>
            </template>
            <el-menu-item-group>
              <el-menu-item index="1-1"><router-link to="/main/phrase">热评管理</router-link></el-menu-item>
              <el-menu-item index="1-1"><router-link to="/main/article">文章管理</router-link></el-menu-item>
              <el-menu-item index="1-1"><router-link to="/main/website">网站管理</router-link></el-menu-item>
            </el-menu-item-group>
          </el-submenu>
          <el-submenu index="2">
            <template slot="title">
              <i class="el-icon-s-tools"></i>
              <span>系统设置</span>
            </template>
            <el-menu-item-group>
              <el-menu-item index="2-1"><router-link to="/main/user">用户管理</router-link></el-menu-item>
              <el-menu-item index="2-2"><router-link to="/main/client">客户端管理</router-link></el-menu-item>
              <el-menu-item index="2-3"><router-link to="/main/role">角色管理</router-link></el-menu-item>
              <el-menu-item index="2-4"><router-link to="/main/location">位置管理</router-link></el-menu-item>
              <el-menu-item index="2-5"><router-link to="/main/service">服务管理</router-link></el-menu-item>
            </el-menu-item-group>
          </el-submenu>
        </el-menu>
      </el-col>
      <el-col :xl="21">
        <div class="content-view">
          <router-view/>
        </div>
      </el-col>
    </el-row>
    <!-- <el-container>
      <el-aside width="auto">
        <el-menu
          default-active="2"
          class="el-menu-vertical-demo">
          <el-submenu index="1">
            <template slot="title">
              <i class="el-icon-postcard"></i>
              <span>内容管理</span>
            </template>
            <el-menu-item-group>
              <el-menu-item index="1-1"><router-link to="/main/phrase">热评管理</router-link></el-menu-item>
              <el-menu-item index="1-1"><router-link to="/main/article">文章管理</router-link></el-menu-item>
              <el-menu-item index="1-1"><router-link to="/main/website">网站管理</router-link></el-menu-item>
            </el-menu-item-group>
          </el-submenu>
          <el-submenu index="2">
            <template slot="title">
              <i class="el-icon-s-tools"></i>
              <span>系统设置</span>
            </template>
            <el-menu-item-group>
              <el-menu-item index="2-1"><router-link to="/main/user">用户管理</router-link></el-menu-item>
              <el-menu-item index="2-2"><router-link to="/main/client">客户端管理</router-link></el-menu-item>
              <el-menu-item index="2-3"><router-link to="/main/role">角色管理</router-link></el-menu-item>
              <el-menu-item index="2-4"><router-link to="/main/location">位置管理</router-link></el-menu-item>
              <el-menu-item index="2-5"><router-link to="/main/service">服务管理</router-link></el-menu-item>
            </el-menu-item-group>
          </el-submenu>
        </el-menu>
      </el-aside>
      <el-main>
        <div class="content-view">
          <router-view/>
        </div>
      </el-main>
    </el-container> -->
  </div>
</template>

<script>

export default {
  name: 'Main'
}
</script>

<style>
  .el-menu{
    text-align: left;
    font-size: 50px;
    border: none;
  }
  .el-aside{
    border-right: 1px solid #ccc;
    min-height: 100vh;
  }
  .content-view{
    padding: 15px;
  }
</style>
